import { createSlice } from '@reduxjs/toolkit'
import SettingsService, { UserSettings } from 'src/modules/settings/settingsService'
import { AppDispatch } from 'src/modules/store'

let defaultSettings: UserSettings = SettingsService.load() || { theme: 'default' }

export interface SettingsState {
  initLoading: boolean
  saveLoading: boolean
  userSettings: typeof defaultSettings
}
const initialState: SettingsState = {
  initLoading: false,
  saveLoading: false,
  userSettings: defaultSettings,
}

const settingsSlice = createSlice({
  name: 'settingsSlice',
  initialState: initialState,
  reducers: {
    saveIsDark: (state, action) => {
      state.userSettings.theme.isDark = action.payload.isDark
    },
  },
})

export const settingsThunkActions = {
  saveIsDark: (isDark: boolean) => async (dispatch: AppDispatch) => {
    SettingsService.setIsDark(isDark)
    dispatch(settingsSlice.actions.saveIsDark({ isDark }))
  },
}

export default settingsSlice
